import { $when, Show } from '../c-mp/comp/Show'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { json } from '../c-mp/fun/json'
import { useEffect } from '../c-mp/fun/useEffect'
import { mutateState, useState } from '../c-mp/fun/useState'
import { addIds } from '../fun/addIds'
import { markClouds } from '../fun/markClouds'
import { markRelationship } from '../fun/markRelationship'
import { setPageTitle } from '../fun/setPageTitle'
import { appState } from '../model/appState'
import { _ } from '../model/ccc'
import type { IData } from '../model/IData'

enum State {
	LoggedOutLoadingData,
	LoggedOut,
	LoggingIn,
	LoggedInLoadingData,
	LoggedInErrorLoadingData,
}

export const LogInComp = defineComponent<{}>('LogInComp', (props, $) => {
	setPageTitle('Bejelentkezés')

	const state = useState('state', {
		it: State.LoggedOutLoadingData,
		message: undefined as undefined | string,
	})

	let passInputRef: HTMLInputElement

	useEffect('logInEffect', () => {
		if (state.it === State.LoggedOutLoadingData) {
			loadData()
		} else if (state.it === State.LoggedInLoadingData) {
			loadData()
		}
	})

	async function logIn() {
		const pass = passInputRef.value
		if (!pass) {
			mutateState('logIn', 'set message [t8mcd4]', () => {
				state.message = `Hiányzó jelszó!`
			})
			return
		}
		try {
			mutateState('logIn', 'set state to logging in [t8mcff]', () => {
				state.it = State.LoggingIn
			})
			const formData = new FormData()
			formData.append('pass', pass)
			const response = await fetch('/login', {
				method: 'POST',
				body: formData,
			})
			if (response.ok) {
				mutateState(
					'logIn',
					'set state to logged in, loading data [t8mcgr]',
					() => {
						state.message = undefined
						state.it = State.LoggedInLoadingData
					},
				)
			} else {
				mutateState(
					'logIn',
					'set state to logged out with wrong pass [t8mchq]',
					() => {
						state.message =
							response.status === 429
								? `Túl sok próbálkozás! Türelem!`
								: `Hibás jelszó!`
						state.it = State.LoggedOut
					},
				)
			}
		} catch (e) {
			mutateState(
				'logIn',
				'set state to logged out with error [t8mcgr]',
				() => {
					state.message = `Hiba történt bejelentkezés közben. Próbáld újra később!`
					state.it = State.LoggedOut
				},
			)
		}
	}

	async function loadData() {
		try {
			const response = await fetch('/json', { credentials: 'include' })
			if (response.ok) {
				const data = (await response.json()) as IData
				addIds(data)
				markClouds(data)
				markRelationship(data)
				mutateState('loadData', 'set data [t8qrc1]', () => {
					appState.data = data
				})
			} else if (response.status === 401) {
				mutateState('loadData', 'set state to logged out [t8mcjn]', () => {
					state.it = State.LoggedOut
					state.message = undefined
				})
			} else {
				throw new Error(
					json`[t8mbtk] Error loading data: ${response.status} ${response.statusText}`,
				)
			}
		} catch (e) {
			console.error(e)
			mutateState(
				'loadData',
				'set state to logged in, error loading data [t8mckz]',
				() => {
					state.it = State.LoggedInErrorLoadingData
					state.message = `Hiba történt az adatok betöltése közben. Próbáld újra később!`
				},
			)
		}
	}

	return (
		<Show
			debugName='Bejelentkezés: adatok betöltése'
			it={$when(
				() => state.it !== State.LoggedOutLoadingData,
				() => (
					<div class={_.ccc_form_page}>
						<Show
							debugName='Bejelentkezés: hiba'
							it={$when(
								() => state.it === State.LoggedInErrorLoadingData,
								() => (
									<>
										<h1>Hiba az adatok betöltése közben</h1>
										<p>
											<button onclick={loadData}>Próbáld újra</button>
										</p>
									</>
								),
							)}
							else={() => (
								<>
									<h1>
										<b>Parditka</b> családfa
									</h1>
									<h2>Mondd jóbarát, és lépj be!</h2>
									<form class={_.ccc_display_contents}>
										<p>
											<input
												ref={(it) => (passInputRef = it)}
												type='password'
												disabled={() => state.it !== State.LoggedOut}
											/>
										</p>
										<Show
											debugName='Bejelentkezés: üzenet'
											it={$when(
												() => state.message,
												() => (
													<p style={{ color: 'crimson' }}>
														<Slot get={() => state.message} />
													</p>
												),
											)}
										/>
										<p>
											<button
												class={_.ccc_button__rounded}
												onclick={logIn}
												disabled={() => state.it !== State.LoggedOut}
											>
												Belépek
											</button>
										</p>
									</form>
								</>
							)}
						/>
					</div>
				),
			)}
		/>
	)
})
